import { centerDateKey } from './geolocation';

// Whole VND, grouped the Vietnamese way: 1.250.000 ₫
export function formatVnd(value: number | null | undefined) {
    if (value === null || value === undefined) return '—';
    return `${Math.round(value).toLocaleString('vi-VN')} ₫`;
}

// Digits only, so "1.250.000", "1,250,000" and "1250000" all mean the same amount.
export function parseMoneyInput(value: string): number | null {
    const digits = value.replace(/[^\d]/g, '');
    if (!digits) return null;
    return Number(digits);
}

export function formatMoneyInput(value: number | null | undefined) {
    return value === null || value === undefined ? '' : Math.round(value).toLocaleString('vi-VN');
}

export function formatHours(hours: number) {
    return `${hours.toLocaleString('vi-VN', { maximumFractionDigits: 2 })} giờ`;
}

// "YYYY-MM" of today in Vietnam time.
export function currentMonthKey(now = new Date()) {
    return centerDateKey(now).slice(0, 7);
}

export function monthRange(monthKey: string) {
    const [year, month] = monthKey.split('-').map(Number);
    const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
    return { from: `${monthKey}-01`, to: `${monthKey}-${String(lastDay).padStart(2, '0')}` };
}

// "dd/MM/yyyy" from "YYYY-MM-DD" without going through time zones.
export function formatDateKey(dateKey: string) {
    const [year, month, day] = dateKey.split('-');
    return `${day}/${month}/${year}`;
}

export function formatWeekday(dateKey: string) {
    return ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'][new Date(`${dateKey}T12:00:00Z`).getUTCDay()];
}
